import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-skill-history',
  templateUrl: './skill-history.component.html',
  styleUrls: ['./skill-history.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class SkillHistoryComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>(); 
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public playerRating;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public searchby;
  public yearOptions: any[] = [];
  public selectedYear;
  public yearRangeForChart = environment.yearRangeForChart;
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
  ) {

  }
  ngOnInit(): void {
    for (let i = 0; i < this.yearRangeForChart; i++) {
      let year = Number(2000) + i;
      this.yearOptions.push({ year: year.toString() });
    }
    let date = new Date();
    this.selectedYear = { year: date.getFullYear().toString() };
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    this.rankData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Rank',
          data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
          fill: false,
          borderColor: '#42A5F5',
          tension: .4
        },
      ]
    };
    this.skillsData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Skills',
          data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
          fill: false,
          borderColor: '#7CFC00',
          tension: .4
        },
      ]
    };

    this.careerService.getTournamentScoreSkills().pipe(takeUntil(this.destroy$)).subscribe(
      (result: any) => {
        const TotalRating = result?.data?.skill?.map((res: any) => {
          return res?.TotalRating

        })

        this.data = {
          type: 'doughnut',
          weight: 2,
          datasets: [
            {
              label: 'skill',
              data: TotalRating,
              borderRadius: 5,
              cutout: 60,
              cutoutPercentage: 40,
              weight: 5,
              backgroundColor: [
                'rgb(235, 124, 166)',
                'rgb(255, 172, 200)',
                'rgb(204, 111, 248)',
                'rgb(124, 92, 252)',
                'rgb(92, 175, 252)',
                'rgb(161, 169, 254)'
              ],
              hoverOffset: 10,
              spacing: 8,

            }]
        }
      },
    );

    this.userId = this.route.snapshot.paramMap.get("id");
    this.getUserDetails(this.userId);
    this.getCareerDetails();
    this.getOpponentsList();
    this.getHighestSkillJumpData();
    this.getTournamentsList();
    this.loadMatches(this.lastTableLazyLoadEvent);
    this.getTournamentScorSkills();
    this.getPlayerSkills(this.userId);
  }
  
  loadMatches(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 18;
    let query = '';
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 18;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params+"&getUserId="+this.userId;
    this.tournamentsService.getMatchSkillist(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.loading = false;
        this.matchList = [];
        this.matchList = data['items'];
        this.totalRecords = this.matchList.length;
        const rating = this.matchList.forEach((player) => {
          if (player.opponents_data.myRating.looserRating != undefined) {
            const playerRating = player.opponents_data.myRating.looserRating ;
            const oldplayerLastRating = player.opponents_data.myRating.looseroldLastRating;
            if (playerRating > oldplayerLastRating) {
              let addition = playerRating - oldplayerLastRating;
              player.opponents_data.myRating.difference = addition;
              player.opponents_data.myRating.showclass = true;
            } else {
              let subtraction = playerRating - oldplayerLastRating;
               player.opponents_data.myRating.difference = subtraction;
               player.opponents_data.myRating.showclass = false;
            }
          }
          if (player.opponents_data.myRating.winnerRating != undefined) {
            const playerRating = player.opponents_data.myRating.winnerRating ;
            const oldplayerLastRating = player.opponents_data.myRating.winneroldLastRating;
            if (playerRating > oldplayerLastRating) {
              let addition = playerRating - oldplayerLastRating;
              player.opponents_data.myRating.difference = addition;
              player.opponents_data.myRating.showclass = true;
            } else {
              let subtraction = playerRating - oldplayerLastRating;
              player.opponents_data.myRating.difference = subtraction;
              player.opponents_data.myRating.showclass = false;
            }
          }          
          if(player.opponents_data.score != undefined) {
            let playerscore=[];
            player.opponents_data.score.forEach(score =>{              
              playerscore.push(score.player1Set+"-"+score.player2Set);
            })
            
            player.opponents_data.playerScore=playerscore.join(' ');
            
          }

        });

        this.totalRecords = data.totalCount;
      },
      err => {
      });

  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
        }

      }, err => {

      });

  }

  getCareerDetails() {
    this.careerService.getCareerDetails().then(
      data => {

        this.careerDetails = data[0];

      }, err => {

      });
  }

  getOpponentsList() {
    this.opponentsService.getOpponentsList().then(
      data => {
        this.opponentList = data;


      }, err => {

      }
    )
  }
  getHighestSkillJumpData() {
    this.careerService.getHighestSkillJumpDetails().then(
      data => {
        this.highestSkillJumpDetails = data;

      }, err => {

      });
  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        this.tournamentList = data;

      }, err => {

      });
  }
  
  getTournamentScorSkills(){
    this.careerService.getTournamentScoreSkills().pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.playerRating=data.data.highestskilljump.playerRating;
        console.log('playerRating',this.playerRating);
      })
  }
  onClickYear(event) {
    this.selectedYear = event.value;
    this.getPlayerSkills(this.userId);
  }
  getPlayerSkills(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserSkills(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        let skillsData = data.data.items;
        this.skillsData = [];
        let labelsArray = [];
        let dataSet = [];
        if (skillsData.length > 0) {
          skillsData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            dataSet.push(Number(element.playerSkills))
          });
        }
        this.skillsData = {
          labels: labelsArray,
          datasets: [
            {
              label: 'Skills',
              data: dataSet,
              fill: false,
              borderColor: '#eb7ca6',
              tension: .4,
              datalabels: {
                align: 'end',
                anchor: 'start'
              }
            },
          ]
        };
      })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
